export var createModalEvent = function createModalEvent() {
  return {
    eventType: 'screen',
    action: 'viewed',
    actionSubject: 'mediaViewerModal',
    name: 'mediaViewerModal'
  };
};